export function readFileAsDataUrl(file, maxMB = 4) {
  return new Promise((resolve, reject) => {
    if (file.size > maxMB * 1024 * 1024) return reject(new Error(`Arquivo maior que ${maxMB}MB. Escolha um arquivo menor.`));
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("Falha ao ler o arquivo."));
    reader.readAsDataURL(file);
  });
}

export function imageToDataUrl(file, maxDim = 800, quality = 0.82) {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith("image/")) return reject(new Error("Envie um arquivo de imagem."));
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const scale = Math.min(1, maxDim / Math.max(img.width, img.height));
        const w = Math.max(1, Math.round(img.width * scale));
        const h = Math.max(1, Math.round(img.height * scale));
        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        canvas.getContext("2d").drawImage(img, 0, 0, w, h);
        resolve(canvas.toDataURL("image/jpeg", quality));
      };
      img.onerror = () => reject(new Error("Imagem inválida."));
      img.src = reader.result;
    };
    reader.onerror = () => reject(new Error("Falha ao ler a imagem."));
    reader.readAsDataURL(file);
  });
}

export async function censorFaces(dataUrl, faces) {
  const img = await new Promise((resolve, reject) => {
    const i = new Image();
    i.onload = () => resolve(i);
    i.onerror = () => reject(new Error("Imagem inválida."));
    i.src = dataUrl;
  });
  const canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0);
  for (const f of faces) {
    if (!f.blur) continue;
    const pad = 0.18;
    const w = f.width * (1 + pad * 2);
    const h = f.height * (1 + pad * 2);
    const x = Math.max(0, f.x - f.width * pad);
    const y = Math.max(0, f.y - f.height * pad);
    const rw = Math.min(w, canvas.width - x);
    const rh = Math.min(h, canvas.height - y);
    if (rw <= 4 || rh <= 4) continue;
    const pw = Math.max(6, Math.round(rw / 24));
    const ph = Math.max(6, Math.round(rh / 24));
    const tmp = document.createElement("canvas");
    tmp.width = pw;
    tmp.height = ph;
    tmp.getContext("2d").drawImage(canvas, x, y, rw, rh, 0, 0, pw, ph);
    ctx.imageSmoothingEnabled = false;
    ctx.drawImage(tmp, 0, 0, pw, ph, x, y, rw, rh);
    ctx.imageSmoothingEnabled = true;
  }
  return canvas.toDataURL("image/jpeg", 0.85);
}
